import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';
import { Router, ActivatedRoute } from '@angular/router'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
  	italics: 'Roboto-Italic.ttf',
  	bolditalics: 'Roboto-MediumItalic.ttf' 
	},
  Cour: {
    normal: 'CourierPrime-Regular.ttf',
    bold: 'CourierPrime-Bold.ttf',
    italics: 'CourierPrime-Italic.ttf',
    bolditalics: 'CourierPrime-BoldItalic.ttf'
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class HomeComponent implements OnInit {
  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 3100;
  tiempoCierraPDF:number=10000;
  maxSinConsolidar:number=4;
  loading:boolean=false;
  item:any=[];
  gpo:any=[];
  prods:any=[];
  descs:any=[];
  forms:any=[];
  idProd:number = -1;
  idDesc:number = -1;
  idForm:number = -1;
  qty:number = 1;
  sub:number = 0;
  des:number = 0;
  total:number = 0;
  ticket:any=[];
  mostrarOtro:boolean = false;
  abrirDescargarPDF:number=-1;
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];
  foliosAreasDefault:number=-1;
  idGpoProd:number=-1;
  recibo:any;

  fecEmi:string="";
  horaEmi:string="";
  qrcode:string="";
  qrcode2:string="";
  qrcode3:string="";
  qrcode4:string="";
  qrcode5:string="";
  qrcode6:string="";
  qrcode7:string="";
  qrcode8:string="";
  qrcode9:string="";
  qrcode10:string="";
  qrcode11:string="";
  qrcode12:string="";
  qrcode13:string="";
  qrcode14:string="";
  qrcode15:string="";
  qrcode16:string="";
  qrcode17:string="";
  qrcode18:string="";
  qrcode19:string="";
  qrcode20:string="";
  qrcode21:string="";
  qrcode22:string="";
  qrcode23:string="";
  qrcode24:string="";
  qrcode25:string="";
  qrcode26:string="";
  qrcode27:string="";
  qrcode28:string="";
  qrcode29:string="";
  qrcode30:string="";
  qtyEstad = 0;
  qtyEstad2 = 0;
  qtyEstad3 = 0;
  qtyEstad4 = 0;
  restoPersonas = 0;
  restoPersonas2 = 0;
  restoPersonas3 = 0;
  restoPersonas4 = 0;
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  consolidaImp:boolean=false;
  generaRecibo:boolean=false;
  generaTicket:boolean=true;
  result:any;
  idGpo:number=1;
  corte:string="";
  grls:any;
  @ViewChild("txtCantidad") txtCantidad:ElementRef;

  thisForm = new FormGroup({
    gpo: new FormControl(this.idGpo, [Validators.required]),
    qty: new FormControl(this.item.qty, [Validators.required]),
    prod: new FormControl(this.item.prod, [Validators.required]),
    monto: new FormControl(this.item.monto, [Validators.required]),
    desc: new FormControl(this.item.desc, []),
    form1: new FormControl(this.item.form, [Validators.required]),
    valor: new FormControl(this.item.valor, []),
    qtyEstad: new FormControl(this.item.qtyEstad, []),
    edad: new FormControl(this.item.edad, []),
    qtyEstad2: new FormControl(this.item.qtyEstad2, []),
    edad2: new FormControl(this.item.edad2, []),
    qtyEstad3: new FormControl(this.item.qtyEstad3, []),
    edad3: new FormControl(this.item.edad3, []),
    qtyEstad4: new FormControl(this.item.qtyEstad4, []),
    edad4: new FormControl(this.item.edad3, []),
    chkConsolida: new FormControl(this.consolidaImp, []),
    chkRecibo: new FormControl(this.generaRecibo, []),
    chkTicket: new FormControl(this.generaTicket, []),
  });

  constructor(private dataService: DataService, private router:Router, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.thisForm.controls["qty"].setValue(1);
    this.idForm = 11;   //--> Efectivo = 11
    this.thisForm.controls["form1"].setValue(this.idForm);
    this.dataService.getG().subscribe(
                      rows => {   
                              this.grls = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGrlsCargados()); 
    this.dataService.getVars("T-PDF").subscribe(
                      rows => {   
                              this.tiempoCierraPDF = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCierraPDFs_Obtenido());
    this.dataService.getVars("PDF_O-D").subscribe(
                      rows => {   
                              this.abrirDescargarPDF = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnPDF_Abrir_Descargar_Obtenido());
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
    this.dataService.getVars("FOL_DEF").subscribe(
                        rows => {   
                                this.foliosAreasDefault = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnFolios_Areas_Default_Obtenido());   
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.gpo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGruposCargados());

    this.dataService.getFormatoImp(1, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());

    this.dataService.getFormAct().subscribe(
                      rows => {   
                              this.forms = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormasCargadas());
    this.dataService.getProdAct(this.idGpo).subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
    this.thisForm.controls["monto"].disable();
    this.thisForm.controls["valor"].disable();
    this.thisForm.controls["desc"].disable();    
    this.txtCantidad.nativeElement.focus();
  }

  fnCierraPDFs_Obtenido(){
    console.log(this.tiempoCierraPDF);
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnPDF_Abrir_Descargar_Obtenido(){
    //console.log(this.abrirDescargarPDF);
  }

  fnFolios_Areas_Default_Obtenido(){
    //console.log(this.foliosAreasDefault);
  }

  fnGrlsCargados(){
    //console.log (this.grls);
    if(this.grls){
      if(this.grls[0]){
        if(this.grls[0].n){
          this.dataService.sN = this.grls[0].n;
          //this.sysN = this.grls[0].n;
        }
        if(this.grls[0].we)
          this.dataService.sWe = this.grls[0].we;
        if(this.grls[0].m)
          this.dataService.sM = this.grls[0].m;
        if(this.grls[0].t1)
          this.dataService.sT1 = this.grls[0].t1;
        if(this.grls[0].t2)
          this.dataService.sT2 = this.grls[0].t2;
        if(this.grls[0].wa)
          this.dataService.sWa = this.grls[0].wa;
        if(this.grls[0].di)
          this.dataService.sDi = this.grls[0].di;
        if(this.grls[0].di2)
          this.dataService.sDi2 = this.grls[0].di2;
        if(this.grls[0].terr){
          this.dataService.sTerr = this.grls[0].terr;
          this.tiempoMsg = this.grls[0].terr;
        }
        if(this.grls[0].ip)
          this.dataService.sIP = this.grls[0].ip;
        if(this.grls[0].rfc)
          this.dataService.sRFC = this.grls[0].rfc;
        if(this.grls[0].cp)
          this.dataService.sCP = this.grls[0].cp;

      }
    }
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("DD/MM/YYYY");
    //console.log(this.fechaEspecial);
  }
  

  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnFormasCargadas(){
    //console.log(this.forms);    
  }

  fnProductosCargados(){
    //console.log(this.prods);
    this.fnCalculaTotal();
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    var auxExiste = 0;
    this.thisForm.controls["desc"].enable();
    //--> Validar que el descuento aplicado exista en el producto selleccionado
    if(this.des > 0){
      for(var d = 0; d < this.descs.length; d++){
        if(this.descs[d].id == this.idDesc){
          auxExiste++;
          d = 9999;
        }
      }
      if(auxExiste == 0){   //--> no existe el descuento en el producto, eliminar info de this.des y de porcentaje
        this.idDesc = -1
        this.thisForm.controls["desc"].reset();
        this.thisForm.controls["valor"].reset();
      }
    }
    this.fnCalculaTotal();
  }

  fnCalculaTotal(){   
    this.qty = 0;  
    this.sub = 0.0;
    this.des = 0.0;
    this.qty = this.thisForm.controls["qty"].value;
    this.thisForm.controls["qtyEstad"].setValue(this.qty);
    this.qtyEstad4 = 0;
    this.restoPersonas3 = 0;
    this.thisForm.controls["qtyEstad4"].setValue(0);
    this.qtyEstad3 = 0;
    this.restoPersonas2 = 0;
    this.thisForm.controls["qtyEstad3"].setValue(0);
    this.qtyEstad2 = 0;
    this.restoPersonas = 0;
    this.thisForm.controls["qtyEstad2"].setValue(0);

    if(this.qty > 25){
      this.thisForm.controls["chkConsolida"].setValue(true);
      this.consolidaImp=true;
      this.thisForm.controls["chkConsolida"].disable();
    }
    else{
      this.thisForm.controls["chkConsolida"].enable();
    }

    //this.qtyEstad  = this.qty;
    //console.log("QTY: " + this.qty)
    //console.log("DESCUENTO: " + this.idDesc)
    if(this.idProd > 0)
      this.sub = this.qty * this.dataService.findItemInObject(this.prods, this.idProd, "id").subTot;
    if(this.idDesc > -1)
      this.des = this.dataService.findItemInObject(this.descs, this.idDesc, "id").valor;

    if(this.des > 0)
      this.total = this.sub * (1 - (this.des / 100));
    else
      this.total = this.sub;
  }

  fnCalculaTotalEstad(){
    var aux1 = this.thisForm.controls["qtyEstad"].value;
    this.restoPersonas = this.qty - (parseInt(aux1));
    //console.log("REsto: " + this.restoPersonas)
    this.thisForm.controls["qtyEstad2"].setValue(this.restoPersonas);
  }

  fnCalculaTotalEstad2(){
    var aux1 = this.thisForm.controls["qtyEstad"].value;
    var aux2 = this.thisForm.controls["qtyEstad2"].value;
    this.restoPersonas2 = this.qty - (parseInt(aux1) + parseInt(aux2));
    //console.log("REsto2: " + this.restoPersonas2)
    this.thisForm.controls["qtyEstad3"].setValue(this.restoPersonas2);
  }

  fnCalculaTotalEstad3(){
    var aux1 = this.thisForm.controls["qtyEstad"].value;
    var aux2 = this.thisForm.controls["qtyEstad2"].value;
    var aux3 = this.thisForm.controls["qtyEstad3"].value;
    this.restoPersonas3 = this.qty - (parseInt(aux1) + parseInt(aux2) + parseInt(aux3));
    //console.log("REsto3: " + this.restoPersonas3)
    this.thisForm.controls["qtyEstad4"].setValue(this.restoPersonas3);
  }

  fnCalculaTotalEstad4(){
    var aux1 = this.thisForm.controls["qtyEstad"].value;
    var aux2 = this.thisForm.controls["qtyEstad2"].value;
    var aux3 = this.thisForm.controls["qtyEstad3"].value;
    var aux4 = this.thisForm.controls["qtyEstad4"].value;
    
    //console.log("REsto: " + (this.qty - (parseInt(aux1) + parseInt(aux2) + parseInt(aux3) + parseInt(aux4))))
  }

  fnBorraDesc(){
    this.idDesc = -1;
    this.thisForm.controls["desc"].reset();
    this.thisForm.controls["valor"].reset();
    //this.thisForm.controls["desc"].disable();
    this.fnCalculaTotal();
  }

  fnResetForm(){
    this.qty = 1
    this.idGpo = 1;
    this.thisForm.controls["gpo"].setValue(this.idGpo);
    this.thisForm.controls["qty"].setValue(1);
    this.idProd = -1
    this.thisForm.controls["prod"].reset();
    this.dataService.getProdAct(this.idGpo).subscribe(
      rows => {   
              this.prods = <any>rows
              },          
      error => this.errMsg = <any>error,
      () => this.fnProductosCargados());
    this.thisForm.controls["monto"].reset();
    this.idDesc = -1;
    this.thisForm.controls["desc"].reset();
    this.idForm = 11
    this.thisForm.controls["form1"].setValue(11);
    this.thisForm.controls["form1"].enable();
    this.thisForm.controls["desc"].disable();
    this.thisForm.controls["valor"].reset();
    this.fnCalculaTotal();
    this.thisForm.controls["edad"].reset();
    var aux = <HTMLInputElement>document.getElementById("genH");
    aux.checked = false;
    aux = <HTMLInputElement>document.getElementById("genM");
    aux.checked = false;
    this.thisForm.controls["edad2"].reset();
    aux = <HTMLInputElement>document.getElementById("genH2");
    if(aux)
      aux.checked = false;
    aux = <HTMLInputElement>document.getElementById("genM2");
    if(aux)
      aux.checked = false;
    this.thisForm.controls["edad3"].reset();
    aux = <HTMLInputElement>document.getElementById("genH3");
    if(aux)
      aux.checked = false;
    aux = <HTMLInputElement>document.getElementById("genM3");
    if(aux)
      aux.checked = false;
    this.thisForm.controls["edad4"].reset();
    aux = <HTMLInputElement>document.getElementById("genH4");
    if(aux)
      aux.checked = false;
    aux = <HTMLInputElement>document.getElementById("genM4");
    if(aux)
      aux.checked = false;

    this.consolidaImp = false;
    this.thisForm.controls["chkConsolida"].setValue(false);
    this.generaRecibo = false;
    this.thisForm.controls["chkRecibo"].setValue(false);
    this.generaTicket =true;
    this.thisForm.controls["chkTicket"].setValue(true);
    this.idGpoProd=-1;
    this.txtCantidad.nativeElement.focus();
  }

  fnFocusCantidad(ev){
    //console.log("FOCUS");
    //console.log(ev);
    var aux=<HTMLInputElement>this.txtCantidad.nativeElement;
    aux.select();
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.dataService.getProdAct(this.idGpo).subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
    }
    if(tipo=="PROD"){
      this.idProd = idEl;
      this.thisForm.controls["prod"].setValue(this.idProd);
      this.thisForm.controls["monto"].setValue(this.dataService.findItemInObject(this.prods, this.idProd, "id").subTot);
      this.fnCalculaTotal();
      var auxProd = this.dataService.findItemInObject(this.prods, this.idProd, "id");
      this.idGpoProd = auxProd.idGpo;
      if(this.idGpoProd > 1){
        this.generaRecibo=true;
        this.thisForm.controls["chkRecibo"].setValue(true);
        this.generaTicket=false;
        this.thisForm.controls["chkTicket"].setValue(this.foliosAreasDefault == 0 ? false : true);
      }
      else{
        this.generaRecibo=false;
        this.thisForm.controls["chkRecibo"].setValue(false);
        this.generaTicket=true;
        this.thisForm.controls["chkTicket"].setValue(true);
      }
      this.dataService.getDescAct(this.idProd).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());

    }   
    if(tipo=="DESC"){
      this.idDesc = idEl;
      if(this.idDesc == 0 || this.idDesc == 1){
        this.thisForm.controls["form1"].disable();
        this.thisForm.controls["form1"].reset();
      }
      else{
        this.thisForm.controls["form1"].enable();
        this.thisForm.controls["form1"].setValue(this.idForm);
      }
      this.thisForm.controls["desc"].setValue(this.idDesc)
      this.thisForm.controls["valor"].setValue(this.dataService.findItemInObject(this.descs, this.idDesc, "id").valor);
      this.fnCalculaTotal();
    }   
    if(tipo=="FORM"){
      this.idForm = idEl;
      
//      this.thisForm.controls["desc"].setValue(this.idDesc)
//      this.thisForm.controls["valor"].setValue(this.dataService.findItemInObject(this.descs, this.idDesc, "id").valor);
//      this.fnCalculaTotal();
    }   
  }

  fnConsolidaImpresion(item){
    setTimeout(() => {
      if(item.checked){
        this.consolidaImp=true;
      }
      else{
        this.consolidaImp=false;
      }
    }, 50); 
  }

  fnGeneraRecibo(item){
    setTimeout(() => {
      if(item.checked){
        this.generaRecibo=true;
      }
      else{
        this.generaRecibo=false;
      }
    }, 50); 
  }

  fnGeneraTicket(item){
    setTimeout(() => {
      if(item.checked){
        this.generaTicket=true;
      }
      else{
        this.generaTicket=false;
      }
    }, 50); 
  }
  
  fnGenerar(){
    this.loading = true;
    this.fecEmi = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial){
      this.fecEmi = this.fechaEspecial;
    }
    this.horaEmi = this.dataService.fnGetAhora();
    //-->Estadisticos:
    var qtyEst1=this.thisForm.controls["qtyEstad"].value;
    var edad1=this.thisForm.controls["edad"].value;
    var auxH = <HTMLInputElement>document.getElementById("genH");
    var auxM = <HTMLInputElement>document.getElementById("genM");
    var qtyEst2=this.thisForm.controls["qtyEstad2"].value;
    var edad2=this.thisForm.controls["edad2"].value;
    var auxH2 = <HTMLInputElement>document.getElementById("genH2");
    var auxM2 = <HTMLInputElement>document.getElementById("genM2");
    var qtyEst3=this.thisForm.controls["qtyEstad3"].value;
    var edad3=this.thisForm.controls["edad3"].value;
    var auxH3 = <HTMLInputElement>document.getElementById("genH3");
    var auxM3 = <HTMLInputElement>document.getElementById("genM3");
    var qtyEst4=this.thisForm.controls["qtyEstad4"].value;
    var edad4=this.thisForm.controls["edad4"].value;
    var auxH4 = <HTMLInputElement>document.getElementById("genH4");
    var auxM4 = <HTMLInputElement>document.getElementById("genM4");

    //console.log("FORMA: " + (this.idDesc < 10 ? this.idDesc : this.idForm));
    this.dataService.insTicket(this.idProd, this.idDesc, this.qty, this.sub, this.des, this.total, this.idDesc < 10 && this.idDesc > -1 ? this.idDesc : this.idForm, this.fecEmi, this.horaEmi).subscribe(
                    rows => {   
                            this.ticket = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnTicketGuardado(qtyEst1,edad1,auxH.checked,auxM.checked, qtyEst2,edad2,auxH2 ? auxH2.checked : null, auxM2 ? auxM2.checked : null, qtyEst3,edad3, auxH3 ? auxH3.checked : null, auxM3 ? auxM3.checked : null, qtyEst4,edad4, auxH4 ? auxH4.checked : null, auxM4 ? auxM4.checked : null));
  }

  fnTicketGuardado(qty1,edad1,h1,m1, qty2,edad2,h2,m2, qty3,edad3,h3,m3, qty4,edad4,h4,m4){
    this.loading = false;
    //console.log(this.ticket);
    /*
    if(qty1 == 1){
      this.dataService.insEstadisticos(this.ticket.folios, qty1 , edad1, h1, m1, null,  null, null).subscribe(
                                rows => {   
                                        this.result = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnEstadistico1Guardado());
    }
    //(qty1 > 1)
    */
    if(qty1 >= 1){
      this.dataService.insEstadisticos(this.ticket.folios.split(',')[0], qty1 , edad1, h1, m1, null,  null, null).subscribe(
                                rows => {   
                                        this.result = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnEstadistico1Guardado());
    }
    if(qty2 > 0){
      this.dataService.insEstadisticos(this.ticket.folios.split(',')[0], qty2 , edad2, h2, m2, null,  null, null).subscribe(
                                rows => {   
                                        this.result = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnEstadistico1Guardado());
    }
    if(qty3 > 0){
      this.dataService.insEstadisticos(this.ticket.folios.split(',')[0], qty3 , edad3, h3, m3, null,  null, null).subscribe(
                                rows => {   
                                        this.result = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnEstadistico1Guardado());
    }
    if(qty4 > 0){
      this.dataService.insEstadisticos(this.ticket.folios.split(',')[0], qty4 , edad4, h4, m4, null,  null, null).subscribe(
                                rows => {   
                                        this.result = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnEstadistico1Guardado());
    }
    if(this.ticket.folios){
      var arrFolio = this.ticket.folios.split(",");
      console.log("TICKET GUARDADO: " + arrFolio.join());
      this.dataService.fnWait(55);
    
      if(this.idGpo >= 1){    //--> INSERTAR FOLIO DE RECIBO
        this.dataService.insRecibo(this.idGpo, (this.idGpo == 4 ? 'SP' : (this.idGpo == 3 ? 'VO' : (this.idGpo == 2 ? 'DI' : (this.idGpo == 1 ? 'TA' : 'X')))), arrFolio[0], arrFolio[arrFolio.length-1], this.fecEmi).subscribe(
                            row => { this.recibo = <any>row; }, 
                            error => this.errMsg = <any>error, 
                            () => this.fnReciboGenerado() );
      }
      this.dataService.insLog(1,'TICKET', this.qty + "|" + this.idProd + "|" + this.idDesc + "|" + this.total + "|" + this.fecEmi + "|" + this.horaEmi + "|" + this.idForm,'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      if(this.consolidaImp && this.generaTicket){
        //--Imprimir grupo de tickets (1 ticket)
        this.qrcode = "G" + arrFolio[0] + ">" + arrFolio[arrFolio.length-1]  + "|" + this.fecEmi + "|" + this.horaEmi;
        this.fnImprimir(arrFolio[0] + '\nal ' + arrFolio[arrFolio.length-1], 0);        
      }
      else{
        //--Imprimir tickets (1x1, multiples)
        for(var i = 0; i < arrFolio.length; i++){
          if(i==0)
            this.qrcode = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==1)
            this.qrcode2 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==2)
            this.qrcode3 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==3)
            this.qrcode4 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==4)
            this.qrcode5 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==5)
            this.qrcode6 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==6)
            this.qrcode7 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==7)
            this.qrcode8 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==8)
            this.qrcode9 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==9)
            this.qrcode10 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==10)
            this.qrcode11 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==11)
            this.qrcode12 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==12)
            this.qrcode13 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==13)
            this.qrcode14 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==14)
            this.qrcode15 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==15)
            this.qrcode16 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==16)
            this.qrcode17 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==17)
            this.qrcode18 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==18)
            this.qrcode19 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==19)
            this.qrcode20 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==20)
            this.qrcode21 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==21)
            this.qrcode22 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==22)
            this.qrcode23 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==23)
            this.qrcode24 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==24)
            this.qrcode25 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==25)
            this.qrcode26 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==26)
            this.qrcode27 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==27)
            this.qrcode28 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==28)
            this.qrcode29 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(i==29)
            this.qrcode30 = "F" + arrFolio[i] + "|" + this.fecEmi + "|" + this.horaEmi;
          if(this.generaTicket)
            this.fnImprimir(arrFolio[i], i);
        }
      }
      if(this.generaRecibo){
        //--Imprimir recibo de servicio 
        this.fnImprimirRecibo(arrFolio[0], arrFolio[arrFolio.length-1]);             
      }

      setTimeout(() => {
        this.fnResetForm();
      }, 750);
    }
    else{
      console.log("ERROR AL INSERTAR");
    }
  }

  fnReciboGenerado(){
    //console.log(this.recibo);
  }

  fnEstadistico1Guardado(){
    //console.log(this.result);
  }

  fnImprimirRecibo(folio:string, folioFin:string){
    this.dataService.insLog(1, 'IMPRIMIR', "RECIBO", folio != folioFin ? folio + " al " + folioFin : folio).subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(9, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionReciboCargados(9, folio, folioFin));              

  }

  fnImprimir(folio:string, i:number){
    var idFormato = 3;  //-->>> Formato 1 = Ticket impresora matriz, 2 = Ticket impresora térmica, 2 = Ticket térmico (Comprobante Simplificado)
    this.dataService.insLog(1,'IMPRIMIR', "TICKETv" + idFormato, folio).subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato, folio, i));              
  }

  fnElementosImpresionCargados(idFormato, folio, ii){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";
    var auxQR;
    if(ii==0)
      auxQR = <HTMLImageElement>document.getElementById("imgQR"); 
    if(ii==1)
      auxQR = <HTMLImageElement>document.getElementById("imgQR2"); 
    if(ii==2)
      auxQR = <HTMLImageElement>document.getElementById("imgQR3"); 
    if(ii==3)
      auxQR = <HTMLImageElement>document.getElementById("imgQR4"); 
    if(ii==4)
      auxQR = <HTMLImageElement>document.getElementById("imgQR5"); 
    if(ii==5)
      auxQR = <HTMLImageElement>document.getElementById("imgQR6"); 
    if(ii==6)
      auxQR = <HTMLImageElement>document.getElementById("imgQR7"); 
    if(ii==7)
      auxQR = <HTMLImageElement>document.getElementById("imgQR8"); 
    if(ii==8)
      auxQR = <HTMLImageElement>document.getElementById("imgQR9"); 
    if(ii==9)
      auxQR = <HTMLImageElement>document.getElementById("imgQR10"); 
    if(ii==10)
      auxQR = <HTMLImageElement>document.getElementById("imgQR11"); 
    if(ii==11)
      auxQR = <HTMLImageElement>document.getElementById("imgQR12"); 
    if(ii==12)
      auxQR = <HTMLImageElement>document.getElementById("imgQR13"); 
    if(ii==13)
      auxQR = <HTMLImageElement>document.getElementById("imgQR14"); 
    if(ii==14)
      auxQR = <HTMLImageElement>document.getElementById("imgQR15"); 
    if(ii==15)
      auxQR = <HTMLImageElement>document.getElementById("imgQR16"); 
    if(ii==16)
      auxQR = <HTMLImageElement>document.getElementById("imgQR17"); 
    if(ii==17)
      auxQR = <HTMLImageElement>document.getElementById("imgQR18"); 
    if(ii==18)
      auxQR = <HTMLImageElement>document.getElementById("imgQR19"); 
    if(ii==19)
      auxQR = <HTMLImageElement>document.getElementById("imgQR20");
    if(ii==20)
      auxQR = <HTMLImageElement>document.getElementById("imgQR21"); 
    if(ii==21)
      auxQR = <HTMLImageElement>document.getElementById("imgQR22"); 
    if(ii==22)
      auxQR = <HTMLImageElement>document.getElementById("imgQR23"); 
    if(ii==23)
      auxQR = <HTMLImageElement>document.getElementById("imgQR24"); 
    if(ii==24)
      auxQR = <HTMLImageElement>document.getElementById("imgQR25"); 
    if(ii==25)
      auxQR = <HTMLImageElement>document.getElementById("imgQR26"); 
    if(ii==26)
      auxQR = <HTMLImageElement>document.getElementById("imgQR27"); 
    if(ii==27)
      auxQR = <HTMLImageElement>document.getElementById("imgQR28"); 
    if(ii==28)
      auxQR = <HTMLImageElement>document.getElementById("imgQR29"); 
    if(ii==29)
      auxQR = <HTMLImageElement>document.getElementById("imgQR30"); 
 
    var auxImgQR = auxQR.getElementsByTagName("img")[0];
    this.dataService.fnWait(55);
    var arrSpecialStrings = [{
      'TITULO': this.dataService.sDe,
      'RFC': this.dataService.sRFC,
      'DIR1': this.dataService.sDi,
      'FOLIO': folio,
      'FECHAEMI': this.fecEmi + " " + this.horaEmi,
      'PROD': this.dataService.findItemInObject(this.prods, this.idProd, "id").prod,
      'QTY': this.qty,
      'TOTAL': this.consolidaImp ? this.total + '    (' + this.qty + ')' :  this.total / this.qty,
      'NUMASI_LETRA': this.dataService.fnLeeMonto(this.consolidaImp ? this.total :  this.total / this.qty),
      'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    //image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),     
                    image: "logoBlack.png",              
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato != "ƒLOGO" ){
        images.push({
                    image:  auxImgQR.src,
                    fit: [110, 110],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }          
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});

    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: {
        width: 212,
        height: 'auto'
      },
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }

    var pdfWin = window.open('', '_blank');
    if(this.abrirDescargarPDF==1){
      //console.log("open");
      pdfMake.createPdf(this.dd).open({},pdfWin);
    }
    else{
      //console.log("print");
      pdfMake.createPdf(this.dd).print({},pdfWin);
    }
    setTimeout(() => {
      pdfWin.close();
    }, this.tiempoCierraPDF);
  }

  fnElementosImpresionReciboCargados(idFormato, folio, folioFin){    
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";
    this.dataService.fnWait(55);
    var auxProd=this.dataService.findItemInObject(this.prods, this.idProd, "id");
    console.log(auxProd);
    var auxDesc=(this.idDesc >= 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '');
    var auxDescPor=(this.idDesc >= 0 ?  this.dataService.findItemInObject(this.descs, this.idDesc, "id").valor  : '');
    var arrSpecialStrings = [{
      'TITULO': ">> CSI <<",
      'RFC': this.dataService.sRFC,
      'CP': this.dataService.sCP,
      'DIR1': this.dataService.sDi,
      'DIR2': this.dataService.sDi2,
      'TEL': this.dataService.sT1,
      'FOLIO': this.recibo.folioRec ? this.recibo.folioRec : (folio != folioFin ? folio + " al " + folioFin : folio),
      //'FOLIO': folio != folioFin ? folio + " al " + folioFin : folio,
      'FECHAEMI': this.fecEmi + " " + this.horaEmi,
      'AREA': auxProd.grupo.toUpperCase(),
      'CATEG': auxProd.categoria + (this.recibo.folioRec ? "   [" + this.fecEmi + "]" : ""),
      'FORMA': this.dataService.findItemInObject(this.forms, this.idForm, "id").forma,      
      'LINEA1': "A" + auxProd.idGpo + "   " + this.dataService.fnLlenaEspacios(auxProd.prod.toUpperCase().replace("VISITA GUIADA", "VG") + " " + auxDesc, 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios(this.qty.toString(), 4, "ANTES") + "   " + this.dataService.fnLlenaEspacios(auxDescPor.toString(), 3, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(auxProd.subTot), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(this.total,2), 12, "ANTES"),
      'LINEA2': "",
      'LINEA3': "",
      'LINEA4': "",
      'LINEA5': "",
      'LINEA6': "",
      'LINEA7': "",
      'LINEA8': "",
      'LINEA9': "",
      'LINEAA': "",
      'LINEAB': "",
      'LINEAC': "",
      'LINEAD': "",
      'LINEAE': "",
      'TOTAL': "$ " + this.dataService.fnFormatMoney(this.total,2),
      'NUMASI_LETRA': this.dataService.fnLeeMonto(this.total),
      'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    //image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    image: "logoBlack.png",
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }          
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      pageSize: this.formato[index].pageSize,
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    var pdfWin2 = window.open('', '_blank');
    if(this.abrirDescargarPDF==1){
      //console.log("open");
      pdfMake.createPdf(this.dd).open();
    }
    else{
      //console.log("print");
      pdfMake.createPdf(this.dd).print();
    }
    setTimeout(() => {
      pdfWin2.close();
    }, this.tiempoCierraPDF);
  }

  fnCorte(){
    //console.log("corte");
    var aux;
    aux = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial)
      aux = this.fechaEspecial;
    this.dataService.getCorte(aux).subscribe(
                                rows => {   
                                        this.corte = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnCorteCargado());
  }

  fnCorteCargado(){
    //console.log(this.corte);
    setTimeout(() => {
      this.corte = "";
    }, 3000);
  }





}
